module.exports = __webpack_public_path__ + "img/symbol_2.8c1ab777.png";